var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "browser 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.84375 10.7812C10.6204 10.7812 11.25 10.1517 11.25 9.375C11.25 8.59835 10.6204 7.96875 9.84375 7.96875C9.0671 7.96875 8.4375 8.59835 8.4375 9.375C8.4375 10.1517 9.0671 10.7812 9.84375 10.7812Z",
    fill: "#8f65da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.5312 10.7812C15.3079 10.7812 15.9375 10.1517 15.9375 9.375C15.9375 8.59835 15.3079 7.96875 14.5312 7.96875C13.7546 7.96875 13.125 8.59835 13.125 9.375C13.125 10.1517 13.7546 10.7812 14.5312 10.7812Z",
    fill: "#8f65da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.2188 10.7812C19.9954 10.7812 20.625 10.1517 20.625 9.375C20.625 8.59835 19.9954 7.96875 19.2188 7.96875C18.4421 7.96875 17.8125 8.59835 17.8125 9.375C17.8125 10.1517 18.4421 10.7812 19.2188 10.7812Z",
    fill: "#8f65da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6562 24.375V8.4375C42.6562 5.07188 39.9281 2.34375 36.5625 2.34375C29.3587 2.34375 15.6412 2.34375 8.4375 2.34375C5.07188 2.34375 2.34375 5.07188 2.34375 8.4375V36.5625C2.34375 39.9281 5.07188 42.6562 8.4375 42.6562H22.5C23.2763 42.6562 23.9062 42.0262 23.9062 41.25C23.9062 40.4738 23.2763 39.8438 22.5 39.8438H8.4375C6.62437 39.8438 5.15625 38.3756 5.15625 36.5625V8.4375C5.15625 6.62437 6.62437 5.15625 8.4375 5.15625H36.5625C38.3756 5.15625 39.8438 6.62437 39.8438 8.4375V24.375C39.8438 25.1513 40.4738 25.7812 41.25 25.7812C42.0262 25.7812 42.6562 25.1513 42.6562 24.375Z",
    fill: "#8f65da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.25 13.5938H3.75C2.97375 13.5938 2.34375 14.2237 2.34375 15C2.34375 15.7763 2.97375 16.4062 3.75 16.4062H41.25C42.0262 16.4062 42.6562 15.7763 42.6562 15C42.6562 14.2237 42.0262 13.5938 41.25 13.5938Z",
    fill: "#8f65da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.232 40.4437L36.2926 34.8187C35.8482 34.1831 34.9707 34.0275 34.3351 34.4737C33.6995 34.9181 33.5438 35.7956 33.9901 36.4312L37.9276 42.0562C38.3738 42.6919 39.2513 42.8475 39.887 42.4012C40.5226 41.9569 40.6782 41.0794 40.232 40.4437Z",
    fill: "#8f65da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3755 30.1575C38.173 28.3087 32.3737 24.9637 29.2443 23.1581C28.3818 22.6612 27.3112 22.7081 26.4955 23.2781C25.6818 23.8481 25.2712 24.84 25.4437 25.8187C26.0699 29.3775 27.2305 35.9719 27.8718 39.6131C28.0462 40.6125 28.798 41.415 29.7843 41.655C30.7705 41.8969 31.8055 41.5331 32.4243 40.7269L35.713 36.4406L40.8655 34.8169C41.8349 34.5112 42.5305 33.6619 42.6412 32.6531C42.7518 31.6444 42.2549 30.6637 41.3755 30.1575ZM39.4724 32.3062L34.4437 33.8925C34.168 33.9787 33.9262 34.1475 33.7518 34.3762L30.5418 38.5612L28.3068 25.8637L39.4724 32.3062Z",
    fill: "#8f65da"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.b80f0d5bc827c700ca7972ad7c7de41c.svg";
export { ForwardRef as ReactComponent };